import { gql } from '@/lib/api';
import type { PlatformAdminRole, PlatformPermission } from '@/lib/permissions';

/** OS-1717 — rol y capacidades de la sesión, resueltos por el API (la consola no tiene la matriz). */
export interface PlatformSession {
  id: string;
  email: string;
  role: PlatformAdminRole;
  permissions: PlatformPermission[];
  /** `all` | `tenant` | `own`. */
  auditScope: string;
}

export { PLATFORM_SESSION_QUERY_KEY } from '@/lib/permissions';

const PLATFORM_ME = /* GraphQL */ `
  query PlatformMe {
    platformMe {
      id
      email
      role
      permissions
      auditScope
    }
  }
`;

export async function getPlatformSession(): Promise<PlatformSession> {
  const data = await gql<{ platformMe: PlatformSession }>(PLATFORM_ME);
  return data.platformMe;
}
